import React from 'react';

function Skeleton() {
  
  return (
		<div className="image-grid-item skeleton is-image fade-in animated"></div>
	);
}

export default Skeleton;